import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Flex, FlexProps, theme, Typography } from 'antd';
import cn from 'classnames';

import { BOT_URL } from 'features/Telegram';
import { useMedia } from 'shared/hooks';

import styles from './Subscribe.module.scss';

interface ISubscribeProps extends Omit<FlexProps, 'children'> {
	size?: 'lg' | 'md';
}

export const Subscribe: FC<ISubscribeProps> = ({ className, size = 'lg', ...props }) => {
	const { t } = useTranslation();
	const {
		token: { colorIcon },
	} = theme.useToken();
	const isMd = useMedia() || size === 'md';

	return (
		<Flex
			{...props}
			gap={20}
			align={isMd ? 'start' : 'center'}
			justify="space-between"
			vertical={isMd}
			className={cn(className, styles.subscribe, styles[size])}
			style={{ color: colorIcon }}>
			<Flex vertical gap={8}>
				<Typography.Title level={5} style={{ margin: 0, lineHeight: '24px' }}>
					{t('Подпишитесь на Telegram-бот')}
				</Typography.Title>
				<Typography.Text type="secondary">
					{t('Чтобы получать уведомления по движению на балансе, подключению на оффер и верификации площадок.')}
				</Typography.Text>
			</Flex>

			<Button href={BOT_URL} target="_blank">
				{t('Подписаться')}
			</Button>
		</Flex>
	);
};
